module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bolditalic-webfont.00a1cd13.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-bolditalic-webfont.ttf
// module id = 511
// module chunks = 0